<template>
    <div class="cert-skeleton" aria-busy="true" :aria-label="$t('student.certificates.loading')">
        <div v-for="n in 4" :key="n" class="cert-skeleton__row">
            <span class="cert-skeleton__thumb"></span>
            <span class="cert-skeleton__lines">
                <i></i>
                <i></i>
            </span>
            <span class="cert-skeleton__badge"></span>
            <span class="cert-skeleton__action"></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CertificateSkeleton',
    };
</script>

<style scoped>
    .cert-skeleton {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .cert-skeleton__row {
        display: grid;
        grid-template-columns: 145px 1fr 120px 160px;
        gap: 16px;
        align-items: center;
        padding: 16px;
        border: 1px solid var(--certs-line, #e8eaf0);
        border-radius: 14px;
    }

    .cert-skeleton__thumb,
    .cert-skeleton__lines i,
    .cert-skeleton__badge,
    .cert-skeleton__action {
        display: block;
        border-radius: 10px;
        background: linear-gradient(90deg, #eef1f5 25%, #f7f8fb 37%, #eef1f5 63%);
        background-size: 400% 100%;
        animation: cert-shimmer 1.3s ease infinite;
    }

    .cert-skeleton__thumb {
        width: 145px;
        height: 90px;
    }

    .cert-skeleton__lines i {
        height: 14px;
        margin-bottom: 8px;
    }

    .cert-skeleton__lines i:last-child {
        width: 45%;
        margin-bottom: 0;
    }

    .cert-skeleton__badge {
        height: 28px;
    }

    .cert-skeleton__action {
        height: 44px;
    }

    @keyframes cert-shimmer {
        0% { background-position: 100% 0; }
        100% { background-position: 0 0; }
    }

    @media (max-width: 960px) {
        .cert-skeleton__row {
            grid-template-columns: 96px 1fr;
        }

        .cert-skeleton__badge,
        .cert-skeleton__action {
            display: none;
        }

        .cert-skeleton__thumb {
            width: 96px;
            height: 72px;
        }
    }
</style>
